<template>
  <div class="vacation-hotel">
    <a v-if="hotel.link" :href="hotel.link" target="_blank">
      <i class="icon icon-info"></i>
    </a>
    <h4>{{ hotel.title }}</h4>
    <h5 v-if="hotel.room_type">{{ $t("סוג חדר") }}: {{ hotel.room_type }}</h5>
    <div v-if="hotel.rating" class="rating">
      <i class="icon icon-star"></i>
      {{ hotel.rating }}
    </div>
    <div v-if="hotel.tag" class="vacation-hotel-tag">{{ hotel.tag }}</div>
  </div>
</template>

<script>
export default {
  props: {
    hotel: {
      type: Object,
      default: {}
    }
  }
};
</script>
